@if (!(policy$ | async) && !!policyErrorList?.length) {
  <div class="column eight flex-min-0 margin-30">
    <ds-error-message [errorList]="policyErrorList"></ds-error-message>
  </div>
}
<layout-sidebar [sidebarVisible]="!newTemplate">
  <div class="main">
    @if (policy$ | async; as policy) {
      <div>
        @if (newTemplate) {
          <div class="row pad-bottom-20">
            <div class="column twelve">
              <life-risk-card
                [policy]="policy"
                [phoneNumber]="amfamPhoneNumber"
                [newTemplate]="true"
              ></life-risk-card>
            </div>
          </div>
          <div class="row pad-top-20 pad-bottom-20 image-container">
            <img src="/assets/images/life-policy.svg" />
          </div>
          @if (policyDocuments$ | async; as documents) {
            @if (documents?.length > 0) {
              <div class="view-coverge-details-wrapper">
                <button (click)="onCoverageDocumentsClicked()">
                  <div>View Coverage Documents</div>
                  <img src="/assets/images/doodle-arrow.svg" alt="View Coverage Details" />
                </button>
              </div>
            }
            @if (documents?.length > 0) {
              <div isRendered (iAmReady)="gotodocuments()" class="new-documents" id="documentsCard">
                <policy-documents [documents]="documents || []"></policy-documents>
              </div>
            }
          }
        } @else {
          <div class="row pad-bottom-20">
            <div class="column twelve">
              <span class="heading-sub-page">{{ policy?.productDescription }}</span>
            </div>
          </div>
          <div class="row pad-bottom-20">
            <div class="column twelve">
              <life-risk-card [policy]="policy" [phoneNumber]="amfamPhoneNumber"></life-risk-card>
            </div>
          </div>
          <div class="row">
            <div class="column twelve">
              <p class="heading-sub-page" dsContent [contentPath]="'policy.policyDetails'"></p>
              <div class="row">
                <ds-accordion [allowMultipleOpenCategories]="true" [allowToggleAccordion]="true">
                  <ds-accordion-category
                    [title]="documents"
                    [isOpen]="true"
                    [showNewBadge]="showNewBadge"
                  >
                    <policy-documents
                      [documents]="(policyDocuments$ | async) || []"
                      [documentType]="'life'"
                    ></policy-documents>
                  </ds-accordion-category>
                </ds-accordion>
              </div>
              <p
                class="margin-top-20 margin-bottom-20"
                dsContent
                [contentPath]="'policy.lifeCoverageInfoNew'"
              ></p>
              <p dsContent [contentPath]="'policy.lifePremiumInfoNew'"></p>
            </div>
          </div>
        }
      </div>
    }
  </div>
  @if (!newTemplate) {
    <aside class="main-aside">
      <links-agents-sidebar></links-agents-sidebar>
    </aside>
  }
</layout-sidebar>
